import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelope = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M2.5 5.8332a1.6666 1.6666 0 0 1 1.6667-1.6667h11.6666A1.6664 1.6664 0 0 1 17.5 5.8332m-15 0v8.3333a1.6665 1.6665 0 0 0 1.6667 1.6667h11.6666A1.6665 1.6665 0 0 0 17.5 14.1665V5.8332m-15 0 7.5 5 7.5-5",
	stroke: "#434343",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.25
}));
const ForwardRef = forwardRef(SvgEnvelope);
export default ForwardRef;
